import { useRef, useState } from 'react';
import { useParams } from 'react-router';
import { loginExam } from '../lib/rpc';
import { submitExternalForm } from '../environments/launch';
import { t } from '../messages';
import './login.css';
import './exam-login.css';

/** Public exam entry: deliberately outside the ordinary NDRC session boundary. */
export function ExamLoginPage() {
  const { examId = '' } = useParams();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const lock = useRef(false);
  async function submit() {
    if (lock.current || !identifier.trim() || !password || !examId) return;
    lock.current = true;
    setBusy(true);
    setError('');
    try {
      const grant = await loginExam(examId, identifier.trim().toLowerCase(), password);
      setPassword('');
      submitExternalForm(window, grant, grant.hostname);
    } catch (failure) {
      setError(failure instanceof Error ? failure.message : t('exam.portal.error'));
      lock.current = false;
      setBusy(false);
    }
  }
  return (
    <main className="exam-public">
      <section className="login-card exam-public-card">
        <header className="login-head">
          <p className="exam-public-brand">{t('exam.portal.brand')}</p>
          <h1 className="login-title">{t('exam.portal.title')}</h1>
          <p className="login-subtitle">{t('exam.portal.hint')}</p>
        </header>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            void submit();
          }}
        >
          <label>
            {t('exam.portal.identifier')}
            <input
              name="username"
              autoComplete="username"
              autoCapitalize="none"
              spellCheck={false}
              value={identifier}
              onChange={(event) => setIdentifier(event.target.value)}
              required
              disabled={busy}
            />
          </label>
          <small>{t('exam.portal.identifierHint')}</small>
          <label>
            {t('exam.portal.password')}
            <input
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
              disabled={busy}
            />
          </label>
          <button type="submit" disabled={busy || !examId || !identifier.trim() || !password}>
            {t(busy ? 'exam.portal.connecting' : 'exam.portal.connect')}
          </button>
          {error && (
            <p role="alert" className="exam-public-error">
              {error}
            </p>
          )}
        </form>
        <p className="exam-public-wait">{t('exam.portal.wait')}</p>
      </section>
    </main>
  );
}
